/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, {useState, useContext} from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"
import { Segment, Sidebar } from "semantic-ui-react";
import CartContext from "../contexts/CartContext"
import HeaderMenu from "../components/HeaderMenu"
import SidebarMenu from "../components/HeaderMenu/SidebarMenu"
import Footer from "../components/Footer"

const Layout = ({ children, pathname }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      allWordpressMenusMenusItems(filter: {name: {eq: "MainMenu"}}) {
        edges {
          node {
            name
            items {
              slug
              title
            }
          }
        }
      }
    }
  `)
  let menus = data.allWordpressMenusMenusItems.edges[0].node.items
    .map( menu=>{
      return {
        name: menu.title,
        path: `/${menu.slug}/`,
        exact: false,
      }
    })

  // Treat slash as special
  if (pathname==="/") pathname = "/home/"

  let [showSidebar, setShowSidebar] = useState(false)
  let toggle = ()=>{ setShowSidebar(!showSidebar) }

  const {cart} = useContext(CartContext);
  const numberOfCartItem = cart.length;

  return (
    <>
      <Sidebar.Pushable as={Segment}>
        <SidebarMenu
          Link={Link}
          pathname={pathname}
          items={menus}
          visible={showSidebar}
          numberOfCartItem={numberOfCartItem}
        />

        <Sidebar.Pusher style={{ minHeight: "100vh" }}>
          {/* Header */}
          <HeaderMenu
            Link={Link}
            pathname={pathname}
            items={menus}
            toggle={toggle}
            numberOfCartItem={numberOfCartItem}
          />

          <div

            style={{
              margin: `0 auto`,
              maxWidth: 960,
              padding: `0 1.0875rem 1.45rem`,
            }}
          >
            <main>
              {children}
            </main>


          </div>
          <Footer />

        </Sidebar.Pusher>

      </Sidebar.Pushable>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
